
define(
	'C3.ShoppingExtensions.NewArrivals'
,   [
		'C3.ShoppingExtensions.NewArrivals.Router'
	]
,   function (
		Router
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var environment = container.getComponent("Environment");
			var layout = container.getComponent('Layout');
			var pageType = container.getComponent('PageType');
			//console.log(layout)
			if(layout && environment)
			{
				return new Router(container); 
			}

		}
	};
});
